import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import GlobalButton from "../../../shared/utils/GlobalButton";

const PDIApprovalDialog = ({
  open,
  onClose,
  onSubmit,
  setApproveDialogOpen,
}) => {
  const [pdiDoneBy, setPdiDoneBy] = useState("");
  const [errors, setErrors] = useState({
    pdiDoneBy: false,
  });

  const handleClose = () => {
    // Reset all states when closing
    setPdiDoneBy("");
    setErrors({
      pdiDoneBy: false,
    });
    onClose();
  };

  const handleSubmit = () => {
    // Validate field
    const hasPdiDoneByError = !pdiDoneBy.trim();

    const newErrors = {
      pdiDoneBy: hasPdiDoneByError,
    };

    setErrors(newErrors);

    // If field is empty, return without submitting
    if (hasPdiDoneByError) {
      return;
    }

    onSubmit(pdiDoneBy);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "600px",
        },
      }}
    >
      <DialogTitle>PDI Details</DialogTitle>
      <DialogContent>
        {/* PDI Done By Field */}
        <div className="mb-4">
          <Typography
            component="label"
            variant="body2"
            sx={{
              display: "block",
              fontWeight: 500,
              mb: 1,
              color: errors.pdiDoneBy ? "error.main" : "text.secondary",
            }}
          >
            PDI Done By *
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            type="text"
            fullWidth
            value={pdiDoneBy}
            onChange={(e) => {
              setPdiDoneBy(e.target.value);
              if (errors.pdiDoneBy && e.target.value.trim()) {
                setErrors({ ...errors, pdiDoneBy: false });
              }
            }}
            error={errors.pdiDoneBy}
            helperText={
              errors.pdiDoneBy && (
                <Typography variant="caption" sx={{ color: "error.main" }}>
                  This field is required
                </Typography>
              )
            }
            required
            placeholder="Enter Your Name"
            InputLabelProps={{ shrink: false }}
            inputProps={{ "aria-label": "PDI Done By" }}
            sx={{
              "& .MuiInputLabel-root": {
                transform: "none",
                position: "relative",
                marginBottom: "4px",
                fontSize: "0.875rem",
              },
              "& .MuiInputBase-input::placeholder": {
                opacity: 1,
                color: "text.disabled",
              },
            }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex items-center gap-3 justify-end">
          <GlobalButton variant="secondary" size="medium" onClick={handleClose}>
            Cancel
          </GlobalButton>
          <GlobalButton variant="primary" size="medium" onClick={handleSubmit}>
            Approve
          </GlobalButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default PDIApprovalDialog;
